import React, { useState } from "react";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

const BRAND = { navy: "#062b6c", green: "#00ad0f" };

const slides = [
  {
    id: "leader",
    short: "Global Leader",
    label: "Global Engineering Partner",
    image: "/new_img/fabrication-service.png",
    description:
      "ISO 9001:2015 certified. We deliver advanced engineering, inspection, and lifting solutions across oil & gas, marine, and construction assets.",
  },
  {
    id: "expert",
    short: "Expert Guarantee In Service Delivery",
    label: "Assurance • Integrity • Safety",
    image: "/new_img/crane.jpg",
    description:
      "From concept to execution, our certified inspections, lifting operations, and surveys keep your critical assets safe, compliant, and operational.",
  },
  {
    id: "training",
    short: "Training Solutions",
    label: "Competency & Training Systems",
    image: "/new_img/training-program.png",
    description:
      "As a Quality Assured organization, we are ISO 9001:2015 certified, delivering world-class training solutions tailored to the oil & gas, marine, and construction industries. Our commitment to excellence ensures the highest standards of professional development and operational integrity.",
  },
];

const SpliderHero = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const options = {
    type: "loop",
    gap: "1.5rem",
    autoplay: true,
    pauseOnHover: false,
    resetProgress: false,
    pagination: false,
    arrows: true,
    speed: 700,
  };

  return (
    <section className="relative overflow-hidden bg-[#020617]">
      {/* background grid hint */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.09] [background-image:linear-gradient(to_right,#101827_1px,transparent_1px),linear-gradient(to_bottom,#101827_1px,transparent_1px)] [background-size:40px_40px]" />

      <div className="relative mx-auto flex max-w-6xl flex-col px-6 py-10 lg:py-14">
        {/* top meta row */}
        <div className="mb-6 flex items-center justify-between text-[12px] uppercase tracking-[0.24em] text-slate-400">
          {/* was text-[11px] / tracking-[0.22em] */}
          <span className="flex items-center gap-2">
            <span
              className="h-2 w-2 rounded-full"
              style={{ background: BRAND.green }}
            />
            Scaftech Nigeria • Engineering Control Deck
          </span>
        </div>

        <Splide
          options={options}
          hasTrack={false}
          aria-label="Scaftech hero mission deck"
          className="relative"
          onMoved={(splide) => setActiveIndex(splide.index)}
        >
          <div className="flex flex-col gap-6 md:flex-row md:items-stretch">
            <SplideTrack className="md:flex-1">
              {slides.map((slide, index) => (
                <SplideSlide key={slide.id}>
                  {/* mission card */}
                  <div className="relative h-full rounded-3xl border border-white/10 bg-[#020819]/90 px-6 py-7 shadow-[0_20px_60px_rgba(0,0,0,0.6)] backdrop-blur-xl md:px-8">
                    {/* subtle accent bar */}
                    <div className="absolute inset-x-8 top-0 h-[3px] rounded-b-full bg-gradient-to-r from-[#00ad0f] via-white/40 to-[#062b6c]" />

                    <div className="mb-4 flex items-center justify-between text-[12px] uppercase tracking-[0.24em] text-slate-400">
                      {/* was text-[11px] / tracking-[0.22em] */}
                      <span className="flex items-center gap-2">
                        <span className="text-slate-500">Mission</span>
                        <span className="text-slate-200">
                          0{index + 1} • {slide.short}
                        </span>
                      </span>
                      <span className="hidden sm:inline text-slate-500">
                        ISO 9001:2015
                      </span>
                    </div>

                    <h1 className="mb-3 text-3xl font-semibold uppercase text-slate-50 md:text-4xl lg:text-[2.4rem] lg:leading-tight">
                      {/* was text-2xl md:text-3xl lg:text-[2.1rem] */}
                      <span className="block text-sm font-medium tracking-[0.3em] text-slate-400">
                        {/* was text-xs */}
                        {slide.label}
                      </span>
                      <span className="mt-2 inline-block bg-gradient-to-r from-[#00ad0f] to-[#7fffb0] bg-clip-text text-transparent">
                        {slide.short}
                      </span>
                    </h1>

                    <p className="mb-5 max-w-xl text-base leading-relaxed text-slate-200 md:text-lg">
                      {/* was text-sm md:text-[0.95rem] */}
                      {slide.description}
                    </p>

                    <div className="flex flex-wrap gap-3">
                      <a
                        href="/contact-us"
                        className="inline-flex items-center gap-2 rounded-full bg-slate-50 px-6 py-3 text-sm font-semibold uppercase tracking-[0.2em] text-[#020617] transition-all hover:-translate-y-[1px] hover:bg-white"
                        // was px-5 py-2.5 text-xs tracking-[0.18em]
                      >
                        <span>Talk to an Expert</span>
                      </a>

                      <a
                        href="https://academy.scaftechservices.com"
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-2 rounded-full border border-[#00ad0f]/70 bg-transparent px-6 py-3 text-sm font-semibold uppercase tracking-[0.2em] text-[#bbffcc] backdrop-blur-sm transition-all hover:bg-[#00ad0f] hover:text-white"
                      >
                        <span className="h-2.5 w-2.5 rounded-full bg-[#00ad0f] shadow-[0_0_10px_rgba(0,173,15,0.9)]" />
                        {/* was h-2 w-2 */}
                        <span>Visit Academy</span>
                      </a>
                    </div>
                  </div>
                </SplideSlide>
              ))}
            </SplideTrack>

            {/* image viewport – feels like a live feed window */}
            <div className="md:w-[42%]">
              <div className="relative h-52 overflow-hidden rounded-3xl border border-white/10 bg-slate-900/60 shadow-[0_20px_60px_rgba(0,0,0,0.7)] md:h-full">
                <div className="absolute inset-x-5 top-3 flex items-center justify-between text-[11px] uppercase tracking-[0.24em] text-slate-300">
                  {/* was text-[10px] */}
                  <span>Visual Feed</span>
                  <span className="flex items-center gap-1 text-[10px]">
                    {/* was 9px */}
                    <span className="h-1.5 w-1.5 rounded-full bg-[#00ad0f]" />
                    Live
                  </span>
                </div>
                <img
                  src={slides[activeIndex].image}
                  alt={slides[activeIndex].short}
                  className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                <div className="absolute bottom-4 left-5 right-5 flex items-center justify-between text-[12px] text-slate-100">
                  {/* was text-[11px] */}
                  <span className="truncate">
                    {slides[activeIndex].short}
                  </span>
                  <span className="text-slate-300">
                    0{activeIndex + 1} / 0{slides.length}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* bottom rail – shows all missions */}
          <div className="mt-5 flex flex-wrap items-center gap-3 text-[12px] text-slate-400">
            {/* was text-[11px] */}
            {slides.map((slide, index) => {
              const active = index === activeIndex;
              return (
                <div
                  key={slide.id}
                  className={`flex items-center gap-2 rounded-full border px-3 py-1.5 transition-all ${
                    active
                      ? "border-[#00ad0f]/70 bg-[#00ad0f]/10 text-[#e8ffe9]"
                      : "border-slate-700/60 bg-slate-900/40"
                  }`}
                >
                  <span className="text-[10px] font-mono text-slate-400">
                    {/* was 9px */}
                    0{index + 1}
                  </span>
                  <span className="text-[11px] uppercase tracking-[0.24em]">
                    {/* was 10px tracking-[0.22em] */}
                    {slide.short}
                  </span>
                </div>
              );
            })}
          </div>
        </Splide>
      </div>
    </section>
  );
};

export default SpliderHero;
